'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.FaresOptimizer.LadderDetailsActionsToolbar', []).controller('LadderDetailsActionsToolbarController', require('./controllers/LadderDetailsActionsToolbarController')).directive('rmLadderDetailsActionsToolbar', require('./directives/LadderDetailsActionsToolbarDirective'));